import React from 'react'
// import type { ModalProps } from '@/interface/common.interface'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"

const CommonModal: React.FC<any> = ({ title, show, onClose, className = "max-w-2xl", children }) => {
    return (
        <Dialog open={show} onOpenChange={onClose} >
            <DialogContent className={`overflow-auto max-h-[90vh] ${className}`}  >
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default CommonModal